import { Component, OnInit } from "@angular/core";
import { FormControl, UntypedFormGroup } from "@angular/forms";
import {
  StringCustomFieldConfig,
  SharedModule,
  FormInputComponent,
  CustomDetailComponent,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { Observable, switchMap } from "rxjs";
import { SplitOrderByOrderIdDocument } from "src/generated-gql/graphql";

@Component({
  template: ` <vdr-card
    [title]="'order.split-order-info' | translate"
    style="
        margin-top: calc(var(--space-unit) * 3);
        margin-bottom: calc(var(--space-unit) * 3)
        "
  >
    <pre>{{ data$ | async | json }}</pre>
  </vdr-card>`,
  standalone: true,
  providers: [DataService],
  imports: [SharedModule],
})
export class SplitOrderInfoComponent implements CustomDetailComponent, OnInit {
  entity$: Observable<any>;
  detailForm: UntypedFormGroup;

  data$: Observable<any>;
  constructor(private dataService: DataService) {}
  ngOnInit() {
    this.data$ = this.entity$.pipe(
      switchMap(
        (entity) =>
          this.dataService.query(SplitOrderByOrderIdDocument, { id: entity.id })
            .single$
      )
    );
  }
}
